import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FloatingSubmenuCoordinatorService } from '../../services/floating-submenu-coordinator.service';
import { SigninService } from 'src/app/signin/signin.service';
import { DataManagementService } from 'src/app/pages/data-management/data-management.service';

@Component({
  selector: 'app-historical-submenu',
  templateUrl: './historical-submenu.component.html',
  styleUrls: ['./historical-submenu.component.scss'],
})
export class HistoricalSubmenuComponent implements OnDestroy {
  readonly submenuId = 'historical';

  showSubmenu = false;
  /** Backdrop becomes interactive only after open gesture has finished. */
  backdropEnabled = false;
  submenuLeft = 0;

  private openedAt = 0;
  private backdropTimer: any;
  private coordinatorSubscription: Subscription;

  constructor(
    private submenuCoordinator: FloatingSubmenuCoordinatorService,
    public signinService: SigninService,
    public dataManagementService: DataManagementService,
  ) {
    this.coordinatorSubscription = this.submenuCoordinator.watchActiveSubmenu().subscribe(activeId => {
      // Close only when another menu opens — not when we open ourselves / null from our own close.
      if (activeId && activeId !== this.submenuId) {
        this.forceClose(false);
      }
      if (activeId === null && this.showSubmenu && !this.isWithinOpenGuard()) {
        this.forceClose(false);
      }
    });
  }

  ngOnDestroy(): void {
    this.clearBackdropTimer();
    this.coordinatorSubscription?.unsubscribe();
  }

  showFloatingSubmenu(event?: Event) {
    const target = (event?.currentTarget || event?.target) as HTMLElement | undefined;
    if (target?.getBoundingClientRect) {
      const rect = target.getBoundingClientRect();
      this.submenuLeft = rect.left + rect.width / 2;
    }

    this.clearBackdropTimer();
    this.openedAt = Date.now();
    this.backdropEnabled = false;
    this.submenuCoordinator.open(this.submenuId);
    this.showSubmenu = true;

    // Enable backdrop only after the opening tap/click sequence is done.
    this.backdropTimer = setTimeout(() => {
      this.backdropEnabled = true;
    }, 450);
  }

  toggleFloatingSubmenu(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();

    if (this.showSubmenu) {
      if (this.isWithinOpenGuard()) {
        return;
      }
      this.hideFloatingSubmenu(true);
      return;
    }

    this.showFloatingSubmenu(event);
  }

  toggleSubmenu(event?: Event) {
    this.toggleFloatingSubmenu(event);
  }

  onBackdropClick(event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    if (!this.backdropEnabled || this.isWithinOpenGuard()) {
      return;
    }
    this.hideFloatingSubmenu(true);
  }

  hideFloatingSubmenu(immediate = false, notifyCoordinator = true) {
    if (immediate) {
      this.forceClose(notifyCoordinator);
      return;
    }
    // Keep API compatible; delayed hide not needed anymore.
    this.forceClose(notifyCoordinator);
  }

  canShowVideoPlayback(): boolean {
    return this.signinService.hasVehicleCameraOption(this.dataManagementService.selectedVehicule);
  }

  private isWithinOpenGuard(): boolean {
    return Date.now() - this.openedAt < 800;
  }

  private forceClose(notifyCoordinator: boolean) {
    this.clearBackdropTimer();
    this.showSubmenu = false;
    this.backdropEnabled = false;
    if (notifyCoordinator) {
      this.submenuCoordinator.closeAll();
    }
  }

  private clearBackdropTimer() {
    if (this.backdropTimer) {
      clearTimeout(this.backdropTimer);
      this.backdropTimer = null;
    }
  }
}
